<!-- Tabs -->

<div
  class="h-screen overflow-y-auto surface-200 pb-4"
  [attr.data-testid]="'checkin-container'"
>
  <form [formGroup]="formGroup" [attr.data-testid]="'task-form'">
    <!-- Create New Task -->
    <div
      class="p-2 font-bold flex align-items-center justify-content-between"
      [attr.data-testid]="'tasks-header'"
    >
      <div
        class="w-9 flex md:align-items-center"
        [attr.data-testid]="'task-info-section'"
      >
        <i
          class="fa fa-info-circle mr-2 text-600"
          [attr.data-testid]="'info-icon'"
          [attr.aria-label]="'info-icon'"
        ></i>
        <span class="text-800" [attr.aria-label]="'task-info-label'">{{
          'CLIENT_TASK.TASK_INFO' | translate
        }}</span>
      </div>
      <div class="w-3 text-right" [attr.data-testid]="'create-task-button'">
        <p-button
          icon="fa fa-plus"
          [label]="'CLIENT_TASK.CREATE_NEW_TASK' | translate"
          styleClass="text-sm hidden md:inline-flex"
          (click)="newTask()"
          [attr.aria-label]="'create-new-task-button'"
          [attr.data-testid]="'create-new-task-button'"
        />
        <p-button
          icon="fa fa-plus"
          styleClass="text-sm md:hidden"
          (click)="showTaskCreate = true"
          [attr.aria-label]="'create-new-task-button-mobile'"
          [attr.data-testid]="'create-new-task-button-mobile'"
        />
      </div>
    </div>
    <!-- Create New Task -->

    <!-- Skeleton -->
    @if (showSkeleton) {
      <div [attr.data-testid]="'tasks-skeleton'">
        @for (card of numSequence(2); track card; let i = $index) {
          <div
            class="surface-0 shadow-1 border-round text-sm mt-3"
            [attr.data-testid]="'task-skeleton-card-' + i"
          >
            <!-- Header -->
            <div
              class="flex align-items-center justify-content-between px-2 md:px-3 py-2 font-bold text-900"
              [attr.data-testid]="'task-skeleton-header-' + i"
            >
              @if (showSkeleton) {
                <p-skeleton
                  height="1.35rem"
                  styleClass="w-10rem"
                  [attr.data-testid]="'task-skeleton-title-' + i"
                />
              }
              <div [attr.data-testid]="'task-skeleton-actions-' + i">
                <p-skeleton
                  height="2.15rem"
                  styleClass="w-9rem hidden md:block"
                  [attr.data-testid]="'task-skeleton-desktop-action-' + i"
                />
                <p-skeleton
                  width="2.15rem"
                  height="2.15rem"
                  styleClass="w-9rem md:hidden"
                  [attr.data-testid]="'task-skeleton-mobile-action-' + i"
                />
              </div>
            </div>
            <!-- Header -->
            <!-- Content -->
            <div class="p-3" [attr.data-testid]="'task-skeleton-content-' + i">
              @if (showSkeleton) {
                <p-skeleton
                  height="1.35rem"
                  styleClass="w-full"
                  [attr.data-testid]="'task-skeleton-description-' + i"
                />
              }
              <hr
                class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
              />
              <div
                class="flex flex-wrap"
                [attr.data-testid]="'task-skeleton-details-' + i"
              >
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 pr-1 md:pr-0"
                  [attr.data-testid]="'task-skeleton-due-date-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    [attr.aria-label]="'due-date-label'"
                  >
                    {{ 'Shared.TASK-OPPORTUNITY-INFO.DUE' | translate }}
                  </h6>
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-7rem"
                    [attr.data-testid]="'task-skeleton-due-date-value-' + i"
                  />
                </div>
                <!-- Column -->
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 pl-1 md:pl-0"
                  [attr.data-testid]="'task-skeleton-expected-closure-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    [attr.aria-label]="'expected-closure-label'"
                  >
                    {{
                      'Shared.TASK-OPPORTUNITY-INFO.EXPECTED-CLOSURE-MONTH'
                        | translate
                    }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-10rem"
                      [attr.data-testid]="
                        'task-skeleton-expected-closure-value-' + i
                      "
                    />
                  }
                </div>
                <!-- Column -->
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 mt-3 xl:mt-0 lg:text-center"
                  [attr.data-testid]="'task-skeleton-amount-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    [attr.aria-label]="'amount-label'"
                  >
                    {{ 'Shared.TASK-OPPORTUNITY-INFO.AMOUNT' | translate }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-4rem mx-auto"
                      [attr.data-testid]="'task-skeleton-amount-value-' + i"
                    />
                  }
                </div>
                <!-- Column -->
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 mt-3 xl:mt-0"
                  [attr.data-testid]="'task-skeleton-category-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-0 block uppercase"
                    [attr.aria-label]="'category-label'"
                  >
                    {{
                      'Shared.TASK-OPPORTUNITY-INFO.CATEGORY_TYPE' | translate
                    }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-7rem mt-2"
                      [attr.data-testid]="'task-skeleton-category-value-' + i"
                    />
                  }
                </div>
                <!-- Column -->
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 mt-3 xl:mt-0"
                  [attr.data-testid]="'task-skeleton-convertibility-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-0 block uppercase"
                    [attr.aria-label]="'convertibility-label'"
                  >
                    {{
                      'Shared.TASK-OPPORTUNITY-INFO.CONVERTIBILITY' | translate
                    }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-7rem mt-2"
                      [attr.data-testid]="
                        'task-skeleton-convertibility-value-' + i
                      "
                    />
                  }
                </div>
                <!-- Column -->
                <!-- Column -->
                <div
                  class="w-6 md:w-3 xl:w-2 mt-3 xl:mt-0"
                  [attr.data-testid]="'task-skeleton-opportunity-stage-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-0 block uppercase"
                    [attr.aria-label]="'opportunity-stage-label'"
                  >
                    {{
                      'Shared.TASK-OPPORTUNITY-INFO.OPPORTUNITY-STAGE'
                        | translate
                    }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-7rem mt-2"
                      [attr.data-testid]="
                        'task-skeleton-opportunity-stage-value-' + i
                      "
                    />
                  }
                </div>
                <!-- Column -->
              </div>
              <hr
                class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
              />
              <div [attr.data-testid]="'task-skeleton-interested-in-' + i">
                <h6
                  class="font-medium text-700 text-xs mb-2 block uppercase"
                  [attr.aria-label]="'interested-in-label'"
                >
                  {{ 'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN' | translate }}
                </h6>
                <div
                  class="border-1 border-300 flex flex-wrap"
                  [attr.data-testid]="'task-skeleton-interested-in-items-' + i"
                >
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-1-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-2-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-3-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-4-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-5-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-6-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-7-' + i
                    "
                  />
                  <p-skeleton
                    height="1.35rem"
                    styleClass="w-5rem m-2"
                    [attr.data-testid]="
                      'task-skeleton-interested-in-item-8-' + i
                    "
                  />
                </div>
              </div>
              <hr
                class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
              />
              <div
                class="grid align-items-center"
                [attr.data-testid]="'task-skeleton-notes-section-' + i"
              >
                <!-- Left -->
                <div
                  class="col-12 md:col-9"
                  [attr.data-testid]="'task-skeleton-notes-' + i"
                >
                  <h4
                    class="text-sm mb-1 font-bold"
                    [attr.aria-label]="'task-notes-label'"
                  >
                    {{ 'Shared.TASK-OPPORTUNITY-INFO.TASK-NOTES' | translate }}
                  </h4>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="mt-2"
                      [attr.data-testid]="'task-skeleton-notes-content-' + i"
                    />
                  }
                </div>
                <!-- Left -->
                <!-- Right -->
                <div
                  class="col-12 md:col-3"
                  [attr.data-testid]="'task-skeleton-assigned-to-' + i"
                >
                  <h6
                    class="font-medium text-700 text-xs mb-1 block uppercase"
                    [attr.aria-label]="'assigned-to-label'"
                  >
                    {{ 'Shared.TASK-OPPORTUNITY-INFO.ASSIGNED-TO' | translate }}
                  </h6>
                  @if (showSkeleton) {
                    <p-skeleton
                      height="1.35rem"
                      styleClass="w-7rem mt-2"
                      [attr.data-testid]="
                        'task-skeleton-assigned-to-value-' + i
                      "
                    />
                  }
                </div>
                <!-- Right -->
              </div>
              <hr
                class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
              />
              @if (showSkeleton) {
                <p-skeleton
                  height="1.35rem"
                  styleClass="w-6rem"
                  [attr.data-testid]="'task-skeleton-footer-' + i"
                />
              }
            </div>
            <!-- Content -->
          </div>
        }
      </div>
    } @else {
      <p-tabs
        [value]="activeTabIndex.toString()"
        styleClass="mt-3"
        (valueChange)="onTabChange($event)"
        [attr.data-testid]="'tasks-tabview'"
      >
        <p-tablist>
          <!-- Planned Tasks Tab Header -->
          <p-tab [value]="'0'" [attr.data-testid]="'planned-tasks-tab-header'">
            <div
              class="flex align-items-center gap-2"
              [attr.aria-label]="'planned-tasks-tab-header'"
            >
              <span>{{ 'CLIENT_TASK.PLANNED_TASK_TITLE' | translate }}</span>
              <p-tag
                [value]="scheduledTotalItems.toString()"
                styleClass="ml-2"
                [attr.data-testid]="'planned-tasks-count'"
              />
            </div>
          </p-tab>
          <!-- Completed Tasks Tab Header -->
          <p-tab
            [value]="'1'"
            [attr.data-testid]="'completed-tasks-tab-header'"
          >
            <div
              class="flex align-items-center gap-2"
              [attr.aria-label]="'completed-tasks-tab-header'"
            >
              <span>{{ 'CLIENT_TASK.COMPLETED_TASK_TITLE' | translate }}</span>
              <p-tag
                [value]="completedTotalItems.toString()"
                styleClass="ml-2"
                severity="success"
                [attr.data-testid]="'completed-tasks-count'"
              />
            </div>
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <!-- Planned Tasks Tab Panel -->
          <p-tabpanel [value]="'0'" [attr.data-testid]="'planned-tasks-tab'">
            <!-- Scheduled Tasks Skeleton Loader -->
            @if (scheduledLoading) {
              <div [attr.data-testid]="'scheduled-tasks-skeleton'">
                @for (card of numSequence(3); track card; let i = $index) {
                  <div
                    class="surface-0 shadow-1 border-round text-sm mt-3"
                    [attr.data-testid]="'scheduled-skeleton-card-' + i"
                  >
                    <div
                      class="flex align-items-center justify-content-between px-2 md:px-3 py-2 font-bold text-900"
                      [attr.data-testid]="'scheduled-skeleton-header-' + i"
                    >
                      <p-skeleton
                        height="1.35rem"
                        styleClass="w-10rem"
                        [attr.data-testid]="'scheduled-skeleton-title-' + i"
                      />
                      <p-skeleton
                        height="2.15rem"
                        styleClass="w-9rem"
                        [attr.data-testid]="'scheduled-skeleton-action-' + i"
                      />
                    </div>
                    <div
                      class="p-3"
                      [attr.data-testid]="'scheduled-skeleton-content-' + i"
                    >
                      <p-skeleton
                        height="1.35rem"
                        styleClass="w-full mb-3"
                        [attr.data-testid]="
                          'scheduled-skeleton-description-' + i
                        "
                      />
                      <div class="flex flex-wrap gap-3">
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-7rem"
                          [attr.data-testid]="
                            'scheduled-skeleton-field-' + i + '-1'
                          "
                        />
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-10rem"
                          [attr.data-testid]="
                            'scheduled-skeleton-field-' + i + '-2'
                          "
                        />
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-4rem"
                          [attr.data-testid]="
                            'scheduled-skeleton-field-' + i + '-3'
                          "
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <!-- End Scheduled Tasks Skeleton Loader -->
            @if (!scheduledLoading) {
              <!-- Empty State for Scheduled Tasks -->
              @if ((plannedTasks$ | async)?.length === 0) {
                <div
                  class="text-center py-8"
                  [attr.data-testid]="'scheduled-tasks-empty-state'"
                >
                  <div class="mb-4">
                    <i
                      class="fa fa-calendar-check text-6xl text-400"
                      [attr.aria-label]="'no-scheduled-tasks-icon'"
                    ></i>
                  </div>
                  <h3 class="text-xl font-semibold text-700 mb-2">
                    {{ 'CLIENT_TASK.NO_PLANNED_TASKS' | translate }}
                  </h3>
                  <p class="text-600 mb-4">
                    {{ 'CLIENT_TASK.NO_PLANNED_TASKS_MESSAGE' | translate }}
                  </p>
                  <p-button
                    icon="fa fa-plus"
                    [label]="'CLIENT_TASK.CREATE_NEW_TASK' | translate"
                    (click)="newTask()"
                    [attr.aria-label]="'create-first-task-button'"
                    [attr.data-testid]="'create-first-task-button'"
                  />
                </div>
              }
              <!-- End Empty State -->
              @for (task of plannedTasks$ | async; track task) {
                <div
                  class="surface-0 shadow-1 border-round text-sm mt-3"
                  [attr.data-testid]="'task-card-' + task.id"
                >
                  <!-- Header -->
                  <div
                    class="flex align-items-center justify-content-between px-2 md:px-3 py-2 font-bold text-900"
                    [ngClass]="getBackgroundColor(task.type)"
                    [attr.data-testid]="'task-header-' + task.id"
                  >
                    <div
                      class="flex mr-2"
                      [attr.data-testid]="'task-type-' + task.id"
                    >
                      <i
                        [class]="getTaskTypeIcon(task.type)"
                        [attr.aria-label]="'task-type-icon-' + task.type"
                      ></i>
                      <ng-template #tour>
                        <i
                          class="fa fa-map-marker-alt text-lg mr-2"
                          [attr.aria-label]="'tour-location-icon'"
                        ></i>
                      </ng-template>
                      <span [attr.aria-label]="'task-scheduled-time'">
                        {{
                          'CLIENT_TASK.SCHDEULD_AT'
                            | translate
                              : {
                                  type: task.type,
                                  ago:
                                    task.scheduled_date
                                    | datetimeformat: 'EE, MMMM d, y',
                                  time:
                                    task.scheduled_date
                                    | datetimeformat: 'shortTime',
                                }
                        }}
                      </span>
                    </div>
                    <div [attr.data-testid]="'task-actions-' + task.id">
                      <p-button
                        [label]="'CLIENT_TASK.LOG_NEW_TASK' | translate"
                        styleClass="text-sm p-button-outlined surface-0 hidden md:inline-flex"
                        (click)="SetOutComeDetails(task)"
                        [attr.aria-label]="'log-new-task-button'"
                        [attr.data-testid]="'log-new-task-button'"
                      />
                      <p-button
                        [label]="'CLIENT_TASK.LOG_NEW_TASK_MOB' | translate"
                        styleClass="text-sm p-button-outlined surface-0 md:hidden"
                        (click)="SetOutComeDetails(task)"
                        [attr.aria-label]="'log-new-task-button-mobile'"
                        [attr.data-testid]="'log-new-task-button-mobile'"
                      />
                    </div>
                  </div>
                  <!-- Header -->
                  <!-- Content -->
                  <div
                    class="p-3"
                    [attr.data-testid]="'task-content-' + task.id"
                  >
                    <div
                      class="flex align-items-center"
                      [attr.data-testid]="'task-title-' + task.id"
                    >
                      @if (!getformShowValue('task_title_' + task.id)) {
                        <h4
                          (click)="
                            setformShowValue('task_title_' + task.id, true)
                          "
                          class="text-sm mb-0 font-bold"
                          [ngClass]="
                            FollowUpButton ? 'line-through' : 'no-underline'
                          "
                          [attr.aria-label]="'task-title'"
                        >
                          {{ task.title }}
                        </h4>
                      }
                      @if (getformShowValue('task_title_' + task.id)) {
                        <div
                          class="p-inputgroup"
                          [attr.data-testid]="'task-title-edit-' + task.id"
                        >
                          <input
                            type="text"
                            class="w-full text-sm"
                            pInputText
                            [formControlName]="'task_title_' + task.id"
                            [attr.aria-label]="'edit-task-title-input'"
                          />
                          <button
                            type="button"
                            pButton
                            pRipple
                            icon="fa fa-check"
                            (click)="EditTaskTitle(task)"
                            [attr.aria-label]="'save-task-title-button'"
                            [attr.data-testid]="'save-task-title-button'"
                          ></button>
                        </div>
                      }
                    </div>
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="grid"
                      [attr.data-testid]="'task-details-' + task.id"
                    >
                      <!-- Column -->
                      <div
                        class="col-6 md:col-3 xl:col-2"
                        [attr.data-testid]="'task-due-date-' + task.id"
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'due-date-label'"
                        >
                          {{ 'Shared.TASK-OPPORTUNITY-INFO.DUE' | translate }}
                        </h6>
                        <div class="-ml-1">
                          @if (!getformShowValue('schedule_date_' + task.id)) {
                            <strong
                              (click)="
                                setformShowValue(
                                  'schedule_date_' + task.id,
                                  true
                                )
                              "
                              class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                              [attr.aria-label]="'task-due-date'"
                            >
                              {{
                                task.scheduled_date
                                  | datetimeformat: 'EE, MMMM d, y'
                              }}
                            </strong>
                          }
                          @if (getformShowValue('schedule_date_' + task.id)) {
                            <div
                              class="p-inputgroup"
                              [attr.data-testid]="
                                'task-due-date-edit-' + task.id
                              "
                            >
                              <p-datepicker
                                [showIcon]="true"
                                [formControlName]="'schedule_date_' + task.id"
                                styleClass="w-full"
                                placeholder="Select Date"
                                inputStyleClass="text-sm"
                                (onSelect)="OnScheduleDateSelect($event, task)"
                                [minDate]="minimumDate"
                                [attr.aria-label]="'edit-task-due-date'"
                              />
                            </div>
                          }
                        </div>
                      </div>
                      <!-- Column -->
                      <!-- Column -->
                      <div
                        class="col-6 md:col-3 xl:col-2"
                        [attr.data-testid]="'task-created-date-' + task.id"
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'created-date-label'"
                        >
                          {{ 'TASK_LIST.COLUMNS.CREATED_DATE' | translate }}
                        </h6>
                        <div class="-ml-1">
                          <strong
                            class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                            [attr.aria-label]="'task-created-date'"
                          >
                            {{
                              task.created_date
                                | datetimeformat: 'EE, MMMM d, y'
                            }}
                          </strong>
                        </div>
                      </div>
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2 px-0"
                          [attr.data-testid]="
                            'task-expected-closure-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-2 block uppercase"
                            [attr.aria-label]="'expected-closure-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.EXPECTED-CLOSURE-MONTH'
                                | translate
                            }}
                          </h6>
                          <div class="-ml-1">
                            @if (
                              !getformShowValue(
                                'expected_closure_month_' + task.id
                              )
                            ) {
                              <strong
                                (click)="
                                  setformShowValue(
                                    'expected_closure_month_' + task.id,
                                    true
                                  )
                                "
                                class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                                [attr.aria-label]="'task-expected-closure-date'"
                              >
                                <i class="fa fa-calendar-plus mr-2"></i>
                                {{
                                  task.oppportunity_info.expected_closure_date
                                    | datetimeformat: 'month-year'
                                }}
                              </strong>
                            }
                            @if (
                              getformShowValue(
                                'expected_closure_month_' + task.id
                              )
                            ) {
                              <div
                                class="p-inputgroup ml-2 md:ml-0"
                                [attr.data-testid]="
                                  'task-expected-closure-edit-' + task.id
                                "
                              >
                                <p-datepicker
                                  [showIcon]="true"
                                  dateFormat="MM yy"
                                  class="w-full"
                                  placeholder="Select Date"
                                  [inline]="expectedDateEdit"
                                  view="month"
                                  inputStyleClass="text-sm"
                                  (onSelect)="
                                    OnExpectedClosureDateSelect($event, task)
                                  "
                                  [formControlName]="
                                    'expected_closure_month_' + task.id
                                  "
                                  [attr.aria-label]="
                                    'edit-task-expected-closure-date'
                                  "
                                />
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2 lg:text-center"
                          [attr.data-testid]="'task-amount-' + task.id"
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-2 block uppercase"
                            [attr.aria-label]="'amount-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.AMOUNT' | translate
                            }}
                          </h6>
                          <div class="-ml-1">
                            @if (
                              !getformShowValue(
                                'value_in_minor_currency_' + task.id
                              )
                            ) {
                              <strong
                                (click)="
                                  setformShowValue(
                                    'value_in_minor_currency_' + task.id,
                                    true
                                  )
                                "
                                class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                                [attr.aria-label]="'task-amount'"
                              >
                                {{
                                  task.oppportunity_info.value_in_minor_currency
                                    | currencyformat
                                }}
                              </strong>
                            }
                            @if (
                              getformShowValue(
                                'value_in_minor_currency_' + task.id
                              )
                            ) {
                              <div
                                class="p-inputgroup"
                                [attr.data-testid]="
                                  'task-amount-edit-' + task.id
                                "
                              >
                                <span
                                  class="p-inputgroup-addon"
                                  [attr.aria-label]="'currency-symbol'"
                                  >{{ this.country.currency_symbol }}</span
                                >
                                <app-shared-input-number
                                  [formGroup]="formGroup"
                                  [controlName]="
                                    formGroup.get(
                                      'value_in_minor_currency_' + task.id
                                    )
                                  "
                                  [styleClass]="'w-full text-sm'"
                                  [conditionToFormat]="true"
                                  [attr.aria-label]="'edit-task-amount'"
                                />
                                <button
                                  type="button"
                                  pButton
                                  pRipple
                                  icon="fa fa-check"
                                  class="px-3"
                                  (click)="UpdateAmount(task)"
                                  [attr.aria-label]="'save-task-amount-button'"
                                  [attr.data-testid]="'save-task-amount-button'"
                                ></button>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      <div
                        class="col-6 md:col-3 xl:col-2"
                        [attr.data-testid]="'task-category-' + task.id"
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-0 block uppercase"
                          [attr.aria-label]="'category-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.CATEGORY_TYPE'
                              | translate
                          }}
                        </h6>
                        <strong
                          class="border-none inline-flex align-items-center text-sm p-2"
                          [attr.aria-label]="'task-category-value'"
                          >{{
                            task.name_primary_language ??
                              task.name_secondary_language
                          }}</strong
                        >
                      </div>
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2"
                          [attr.data-testid]="'task-convertibility-' + task.id"
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-0 block uppercase"
                            [attr.aria-label]="'convertibility-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.CONVERTIBILITY'
                                | translate
                            }}
                          </h6>
                          <p-select
                            [options]="convertibility"
                            dropdownIcon="fa fa-chevron-down text-xs"
                            optionLabel="name"
                            class="border-none surface-0 w-7rem"
                            (onChange)="UpdateConvartability($event, task)"
                            [formControlName]="'covertability_' + task.id"
                            [attr.aria-label]="'task-convertibility-dropdown'"
                            [attr.data-testid]="'task-convertibility-dropdown'"
                          >
                            <ng-template pTemplate="selectedItem">
                              @if (SelectedConvertibility(task.id); as convr) {
                                <div class="flex align-items-center">
                                  <span class="mr-2"
                                    ><img
                                      width="20"
                                      src="{{ convr.icon }}"
                                      alt="{{ convr.name }}"
                                  /></span>
                                  <strong class="text-900">{{
                                    convr.name
                                  }}</strong>
                                </div>
                              }
                            </ng-template>
                            <ng-template let-convertibility pTemplate="item">
                              <div class="flex align-items-center">
                                <span class="mr-2"
                                  ><img
                                    width="20"
                                    class="grayscale opacity-50"
                                    src="{{ convertibility.icon }}"
                                    alt="{{ convertibility.name }}"
                                /></span>
                                <div class="text-sm text-600">
                                  {{ convertibility.name }}
                                </div>
                              </div>
                            </ng-template>
                          </p-select>
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2"
                          [attr.data-testid]="
                            'task-opportunity-stage-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-0 block uppercase"
                            [attr.aria-label]="'opportunity-stage-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.OPPORTUNITY-STAGE'
                                | translate
                            }}
                          </h6>
                          <p-select
                            [options]="opportunityStageCollection"
                            dropdownIcon="fa fa-chevron-down text-xs"
                            [formControlName]="'selectedOpportunity_' + task.id"
                            optionLabel="name"
                            styleClass="border-none inline-flex align-items-center text-sm py-0"
                            (onChange)="UpdateOpportunityStage($event, task)"
                            [attr.aria-label]="
                              'task-opportunity-stage-dropdown'
                            "
                            [attr.data-testid]="
                              'task-opportunity-stage-dropdown'
                            "
                          >
                            <ng-template pTemplate="selectedItem">
                              @if (
                                SelectedOpportunity(task.id);
                                as opportunity
                              ) {
                                <div>
                                  <strong class="text-900">{{
                                    opportunity.name
                                  }}</strong>
                                </div>
                              }
                            </ng-template>
                            <ng-template let-opportunity pTemplate="item">
                              <div class="text-sm">{{ opportunity.name }}</div>
                            </ng-template>
                          </p-select>
                        </div>
                      }
                      <!-- Column -->
                    </div>
                    @if (task.oppportunity_info) {
                      <hr
                        class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-0 mb-3"
                      />
                    }
                    @if (task.oppportunity_info) {
                      <div [attr.data-testid]="'task-interested-in-' + task.id">
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'interested-in-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN'
                              | translate
                          }}
                        </h6>
                        <p-autoComplete
                          [formControlName]="'service_type_ids_' + task.id"
                          field="name_primary_language"
                          styleClass="w-full"
                          [suggestions]="filtertedServiceType"
                          (completeMethod)="filterServiceType($event)"
                          (onSelect)="
                            UpdateServiceType(false, $event, formGroup, task)
                          "
                          (onUnselect)="
                            UpdateServiceType(true, $event, formGroup, task)
                          "
                          [multiple]="true"
                          [attr.aria-label]="'task-interested-in-autocomplete'"
                          [attr.data-testid]="'task-interested-in-autocomplete'"
                        />
                      </div>
                    }
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="grid align-items-center"
                      [attr.data-testid]="'task-notes-section-' + task.id"
                    >
                      <!-- Left -->
                      <div
                        class="col-12 md:col-9"
                        [attr.data-testid]="'task-notes-' + task.id"
                      >
                        <h4
                          class="text-sm mb-2 font-bold"
                          [attr.aria-label]="'task-notes-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.TASK-NOTES'
                              | translate
                          }}
                        </h4>
                        @if (!getformShowValue('task_notes_' + task.id)) {
                          <p
                            class="mb-0"
                            [attr.aria-label]="'task-notes-content'"
                          >
                            {{ task.notes }}
                          </p>
                        }
                        @if (getformShowValue('task_notes_' + task.id)) {
                          <div
                            class="p-inputgroup"
                            [attr.data-testid]="'task-notes-edit-' + task.id"
                          >
                            <input
                              type="text"
                              class="w-full text-sm"
                              pInputText
                              [formControlName]="'task_notes_' + task.id"
                              [attr.aria-label]="'edit-task-notes-input'"
                            />
                            <button
                              type="button"
                              pButton
                              pRipple
                              icon="fa fa-check"
                              (click)="EditTaskNotes(task)"
                              [attr.aria-label]="'save-task-notes-button'"
                              [attr.data-testid]="'save-task-notes-button'"
                            ></button>
                          </div>
                        }
                      </div>
                      <!-- Left -->
                      <!-- Right -->
                      <div
                        class="col-12 md:col-3"
                        [attr.data-testid]="'task-assigned-to-' + task.id"
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'assigned-to-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.ASSIGNED-TO'
                              | translate
                          }}
                        </h6>
                        <staff-selector
                          [formGroup]="formGroup"
                          [controlName]="SelectedAssignedFormControl(task.id)"
                          [id]="assignedId(task.assigned_to_staff_id)"
                          [styleClass]="'w-full text-sm border-0'"
                          [showClear]="false"
                          [placeHolder]="
                            'common.PLACEHOLDER.SELECT' | translate
                          "
                          (selectedStaff)="getSelectedStaff($event, task)"
                          [attr.aria-label]="'task-assigned-to-selector'"
                          [attr.data-testid]="'task-assigned-to-selector'"
                        />
                      </div>
                      <!-- Right -->
                    </div>
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="cursor-pointer text-sm text-primary flex align-items-center"
                      pStyleClass="@next"
                      enterFromClass="hidden"
                      enterActiveClass="scalein"
                      leaveToClass="hidden"
                      leaveActiveClass="fadeout"
                      [hideOnOutsideClick]="true"
                      [attr.data-testid]="'task-comments-toggle-' + task.id"
                    >
                      <i
                        class="fa fa-comment"
                        [attr.aria-label]="'comments-icon'"
                      ></i>
                      <span class="mx-2" [attr.aria-label]="'comments-count'"
                        >{{ task.comments ? task.comments.length : 0 }}
                        {{ 'CLIENT_TASK.COMMENTS' | translate }}</span
                      >
                      <i
                        class="fa fa-chevron-down text-xs"
                        [attr.aria-label]="'toggle-comments-icon'"
                      ></i>
                    </div>
                    <div
                      class="hidden"
                      [attr.data-testid]="'task-comments-section-' + task.id"
                    >
                      @if (task.comments && task.comments.length > 0) {
                        <p-table
                          [value]="task.comments"
                          styleClass="shadow-2 p-0 my-3"
                          responsiveLayout="scroll"
                          [attr.data-testid]="'task-comments-table-' + task.id"
                        >
                          <ng-template pTemplate="header">
                            <tr class="text-xs">
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'commenter-header'"
                              ></th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-content-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-date-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT_ON' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-actions-header'"
                              ></th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-comment
                            let-rowIndex="rowIndex"
                          >
                            <tr class="text-sm border-bottom-1 border-300">
                              <td class="py-2 white-space-nowrap relative">
                                <staff-info
                                  [staffId]="comment.comments_updated_by"
                                  [attr.data-testid]="
                                    'commenter-info-' + comment.id
                                  "
                                />
                              </td>
                              <td
                                class="py-2 white-space-nowrap relative"
                                [attr.aria-label]="'comment-content'"
                                [innerHTML]="
                                  sanitizeHtml(comment.comments_content)
                                "
                              ></td>
                              <td
                                class="py-2 white-space-nowrap relative"
                                [attr.aria-label]="'comment-date'"
                              >
                                {{
                                  comment.comments_created_date
                                    | datetimeformat: 'atDate'
                                }}
                              </td>
                              <td class="py-2 white-space-nowrap">
                                <button
                                  pButton
                                  pRipple
                                  type="button"
                                  icon="fa fa-angle-down"
                                  [label]="
                                    'common.BUTTONS.BTN_ACTIONS' | translate
                                  "
                                  iconPos="right"
                                  class="surface-0 p-button-outlined border-400 ml-2 text-600 text-sm"
                                  (click)="commentsAction.toggle($event)"
                                  [attr.aria-label]="'comment-actions-button'"
                                  [attr.data-testid]="
                                    'comment-actions-button-' + comment.id
                                  "
                                ></button>
                                <p-popover
                                  #commentsAction
                                  styleClass="overflow-hidden right-0 text-sm w-6rem"
                                  [attr.aria-label]="'comment-actions-panel'"
                                  [attr.data-testid]="
                                    'comment-actions-panel-' + comment.id
                                  "
                                >
                                  <ul
                                    class="list-none px-0 py-2 text-xs text-600 m-0"
                                  >
                                    <li
                                      class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                                      (click)="DeleteComment(comment)"
                                      [attr.aria-label]="
                                        'delete-comment-button'
                                      "
                                      [attr.data-testid]="
                                        'delete-comment-button-' + comment.id
                                      "
                                    >
                                      <i
                                        class="fa fa-trash-alt text-500 mr-2"
                                      ></i
                                      >Delete
                                    </li>
                                  </ul>
                                </p-popover>
                              </td>
                            </tr>
                            @if (task.comments.length === rowIndex + 1) {
                              <tr
                                class="text-sm border-bottom-1 border-300 vertical-align-top"
                              >
                                <td class="py-2 white-space-nowrap relative">
                                  <staff-info
                                    [staffId]="currentUserDetails.Id"
                                    [attr.data-testid]="'current-user-info'"
                                  />
                                </td>
                                <td
                                  class="py-3 white-space-nowrap relative h-13rem"
                                  colspan="2"
                                >
                                  <p-editor
                                    [formControlName]="
                                      'task_comments_' + task.id
                                    "
                                    styleClass="mb-3"
                                    [style]="{ height: '100px' }"
                                    [attr.aria-label]="'new-comment-editor'"
                                    [attr.data-testid]="
                                      'new-comment-editor-' + task.id
                                    "
                                  />
                                  <p-button
                                    [label]="
                                      'common.BUTTONS.BUTTON-TEXT-SAVE'
                                        | translate
                                    "
                                    [disabled]="
                                      TaskCommentsFormControl(task.id).invalid
                                    "
                                    [loading]="btnLoading"
                                    (click)="CreateComments(task)"
                                    class="text-sm"
                                    [attr.aria-label]="'save-comment-button'"
                                    [attr.data-testid]="
                                      'save-comment-button-' + task.id
                                    "
                                  />
                                </td>
                              </tr>
                            }
                          </ng-template>
                        </p-table>
                      } @else {
                        <p-table
                          [value]="tableData"
                          styleClass="shadow-2 p-0 my-3"
                          responsiveLayout="scroll"
                          [attr.data-testid]="'empty-comments-table-' + task.id"
                        >
                          <ng-template pTemplate="header">
                            <tr class="text-xs">
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'commenter-header'"
                              ></th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-content-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-date-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT_ON' | translate }}
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-data>
                            <tr
                              class="text-sm border-bottom-1 border-300 vertical-align-top"
                            >
                              <td class="py-2 white-space-nowrap relative">
                                <staff-info
                                  [staffId]="currentUserDetails.Id"
                                  [attr.data-testid]="'current-user-info'"
                                />
                              </td>
                              <td
                                class="py-3 white-space-nowrap relative h-13rem"
                                colspan="2"
                              >
                                <p-editor
                                  [formControlName]="'task_comments_' + task.id"
                                  styleClass="mb-3"
                                  [style]="{ height: '100px' }"
                                  [attr.aria-label]="'new-comment-editor'"
                                  [attr.data-testid]="
                                    'new-comment-editor-' + task.id
                                  "
                                />
                                <p-button
                                  [label]="
                                    'common.BUTTONS.BUTTON-TEXT-SAVE'
                                      | translate
                                  "
                                  [disabled]="
                                    TaskCommentsFormControl(task.id).invalid
                                  "
                                  [loading]="btnLoading"
                                  (click)="CreateComments(task)"
                                  class="text-sm"
                                  [attr.aria-label]="'save-comment-button'"
                                  [attr.data-testid]="
                                    'save-comment-button-' + task.id
                                  "
                                />
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      }
                    </div>
                  </div>
                  <!-- Content -->
                </div>
              }
            }
            <!-- Scheduled Tasks Pagination -->
            @if (scheduledTotalItems > scheduledPageSize) {
              <div
                class="mt-3"
                [attr.data-testid]="'scheduled-tasks-pagination'"
              >
                <p-paginator
                  [rows]="scheduledPageSize"
                  [totalRecords]="scheduledTotalItems"
                  [first]="(scheduledPage - 1) * scheduledPageSize"
                  (onPageChange)="onScheduledPageChange($event)"
                  [rowsPerPageOptions]="[10, 25, 50, 100]"
                  [attr.aria-label]="'scheduled-tasks-paginator'"
                  [attr.data-testid]="'scheduled-tasks-paginator'"
                />
              </div>
            }
            <!-- Scheduled Tasks Pagination -->
          </p-tabpanel>
          <!-- End Planned Tasks Tab -->
          <!-- Completed Tasks Tab Panel -->
          <p-tabpanel [value]="'1'" [attr.data-testid]="'completed-tasks-tab'">
            <!-- Completed Tasks Skeleton Loader -->
            @if (completedLoading) {
              <div [attr.data-testid]="'completed-tasks-skeleton'">
                @for (card of numSequence(3); track card; let i = $index) {
                  <div
                    class="surface-0 shadow-1 border-round text-sm mt-3"
                    [attr.data-testid]="'completed-skeleton-card-' + i"
                  >
                    <div
                      class="flex align-items-center justify-content-between px-2 md:px-3 py-2 font-bold text-900"
                      [attr.data-testid]="'completed-skeleton-header-' + i"
                    >
                      <p-skeleton
                        height="1.35rem"
                        styleClass="w-10rem"
                        [attr.data-testid]="'completed-skeleton-title-' + i"
                      />
                      <p-skeleton
                        height="2.15rem"
                        styleClass="w-9rem"
                        [attr.data-testid]="'completed-skeleton-action-' + i"
                      />
                    </div>
                    <div
                      class="p-3"
                      [attr.data-testid]="'completed-skeleton-content-' + i"
                    >
                      <p-skeleton
                        height="1.35rem"
                        styleClass="w-full mb-3"
                        [attr.data-testid]="
                          'completed-skeleton-description-' + i
                        "
                      />
                      <div class="flex flex-wrap gap-3">
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-7rem"
                          [attr.data-testid]="
                            'completed-skeleton-field-' + i + '-1'
                          "
                        />
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-10rem"
                          [attr.data-testid]="
                            'completed-skeleton-field-' + i + '-2'
                          "
                        />
                        <p-skeleton
                          height="1.35rem"
                          styleClass="w-4rem"
                          [attr.data-testid]="
                            'completed-skeleton-field-' + i + '-3'
                          "
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <!-- End Completed Tasks Skeleton Loader -->
            @if (!completedLoading) {
              <!-- Empty State for Completed Tasks -->
              @if ((complitedTasks$ | async)?.length === 0) {
                <div
                  class="text-center py-8"
                  [attr.data-testid]="'completed-tasks-empty-state'"
                >
                  <div class="mb-4">
                    <i
                      class="fa fa-check-circle text-6xl text-400"
                      [attr.aria-label]="'no-completed-tasks-icon'"
                    ></i>
                  </div>
                  <h3 class="text-xl font-semibold text-700 mb-2">
                    {{ 'CLIENT_TASK.NO_COMPLETED_TASKS' | translate }}
                  </h3>
                  <p class="text-600 mb-4">
                    {{ 'CLIENT_TASK.NO_COMPLETED_TASKS_MESSAGE' | translate }}
                  </p>
                </div>
              }
              <!-- End Empty State -->
              @for (task of complitedTasks$ | async; track task) {
                <div
                  class="bg-yellow-50 shadow-1 border-round text-sm mt-3"
                  [attr.data-testid]="'completed-task-card-' + task.id"
                >
                  <!-- Header -->
                  <div
                    class="flex align-items-center justify-content-between px-2 md:px-3 py-2 font-bold text-900"
                    [ngClass]="getBackgroundColor(task.type)"
                    [attr.data-testid]="'completed-task-header-' + task.id"
                  >
                    <div
                      class="flex mr-2"
                      [attr.data-testid]="'completed-task-type-' + task.id"
                    >
                      <i
                        [class]="getTaskTypeIcon(task.type)"
                        [attr.aria-label]="
                          'completed-task-type-icon-' + task.type
                        "
                      ></i>
                      <span [attr.aria-label]="'completed-task-scheduled-time'">
                        {{
                          'CLIENT_TASK.SCHDEULD_AT'
                            | translate
                              : {
                                  type: task.type,
                                  ago:
                                    task.scheduled_date
                                    | datetimeformat: 'EE, MMMM d, y',
                                  time:
                                    task.scheduled_date
                                    | datetimeformat: 'shortTime',
                                }
                        }}
                      </span>
                    </div>
                    @if (!isCompleted(task)) {
                      <div
                        [attr.data-testid]="'completed-task-actions-' + task.id"
                      >
                        <p-button
                          [label]="'CLIENT_TASK.LOG_NEW_TASK' | translate"
                          (click)="SetOutComeDetails(task)"
                          styleClass="text-sm p-button-outlined surface-0 hidden md:inline-flex"
                          [attr.aria-label]="'log-new-task-button'"
                          [attr.data-testid]="'log-new-task-button'"
                        />
                        <p-button
                          [label]="'CLIENT_TASK.LOG_NEW_TASK_MOB' | translate"
                          styleClass="text-sm p-button-outlined surface-0 md:hidden"
                          (click)="SetOutComeDetails(task)"
                          [attr.aria-label]="'log-new-task-button-mobile'"
                          [attr.data-testid]="'log-new-task-button-mobile'"
                        />
                      </div>
                    }
                  </div>
                  <!-- Header -->
                  <!-- Content -->
                  <div
                    class="p-3"
                    [attr.data-testid]="'completed-task-content-' + task.id"
                  >
                    <div
                      class="flex align-items-center"
                      [attr.data-testid]="'completed-task-title-' + task.id"
                    >
                      <h4
                        class="text-sm mb-0 font-bold"
                        [ngClass]="
                          FollowUpButton ? 'line-through' : 'no-underline'
                        "
                        [attr.aria-label]="'completed-task-title'"
                      >
                        {{ task.title }}
                      </h4>
                    </div>
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="grid"
                      [attr.data-testid]="'completed-task-details-' + task.id"
                    >
                      <!-- Column -->
                      <div
                        class="col-6 md:col-3 xl:col-2"
                        [attr.data-testid]="
                          'completed-task-due-date-' + task.id
                        "
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'due-date-label'"
                        >
                          {{ 'Shared.TASK-OPPORTUNITY-INFO.DUE' | translate }}
                        </h6>
                        <div class="-ml-1">
                          <strong
                            class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 border-round"
                            [attr.aria-label]="'completed-task-due-date'"
                          >
                            {{
                              task.scheduled_date
                                | datetimeformat: 'EE, MMMM d, y'
                            }}
                          </strong>
                        </div>
                      </div>
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2 px-0"
                          [attr.data-testid]="
                            'completed-task-expected-closure-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-2 block uppercase"
                            [attr.aria-label]="'expected-closure-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.EXPECTED-CLOSURE-MONTH'
                                | translate
                            }}
                          </h6>
                          <div class="-ml-1">
                            <strong
                              class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 border-round"
                              [attr.aria-label]="
                                'completed-task-expected-closure-date'
                              "
                            >
                              <i class="fa fa-calendar-plus mr-2"></i>
                              {{
                                task.oppportunity_info.expected_closure_date
                                  | datetimeformat: 'month-year'
                              }}
                            </strong>
                          </div>
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2 lg:text-center"
                          [attr.data-testid]="
                            'completed-task-amount-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-2 block uppercase"
                            [attr.aria-label]="'amount-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.AMOUNT' | translate
                            }}
                          </h6>
                          <div class="-ml-1">
                            <strong
                              class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 border-round"
                              [attr.aria-label]="'completed-task-amount'"
                            >
                              {{
                                task.oppportunity_info.value_in_minor_currency
                                  | currencyformat
                              }}
                            </strong>
                          </div>
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      <div
                        class="col-6 md:col-3 xl:col-2"
                        [attr.data-testid]="
                          'completed-task-category-' + task.id
                        "
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-0 block uppercase"
                          [attr.aria-label]="'category-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.CATEGORY_TYPE'
                              | translate
                          }}
                        </h6>
                        <strong
                          class="border-none inline-flex align-items-center text-sm p-2"
                          [attr.aria-label]="'completed-task-category-value'"
                          >{{
                            task.name_primary_language ??
                              task.name_secondary_language
                          }}</strong
                        >
                      </div>
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2"
                          [attr.data-testid]="
                            'completed-task-convertibility-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-0 block uppercase"
                            [attr.aria-label]="'convertibility-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.CONVERTIBILITY'
                                | translate
                            }}
                          </h6>
                          @if (SelectedConvertibility(task.id); as convr) {
                            <div class="flex align-items-center mt-2">
                              <span
                                ><img
                                  width="20"
                                  src="{{ convr.icon }}"
                                  alt="{{ convr.name }}"
                              /></span>
                              <strong
                                class="ml-2"
                                [attr.aria-label]="
                                  'completed-task-convertibility-value'
                                "
                                >{{ convr.name }}</strong
                              >
                            </div>
                          }
                        </div>
                      }
                      <!-- Column -->
                      <!-- Column -->
                      @if (task.oppportunity_info) {
                        <div
                          class="col-6 md:col-3 xl:col-2"
                          [attr.data-testid]="
                            'completed-task-opportunity-stage-' + task.id
                          "
                        >
                          <h6
                            class="font-medium text-700 text-xs mb-0 block uppercase"
                            [attr.aria-label]="'opportunity-stage-label'"
                          >
                            {{
                              'Shared.TASK-OPPORTUNITY-INFO.OPPORTUNITY-STAGE'
                                | translate
                            }}
                          </h6>
                          @if (SelectedOpportunity(task.id); as opportunity) {
                            <strong
                              class="border-none inline-flex align-items-center text-sm p-2"
                              [attr.aria-label]="
                                'completed-task-opportunity-stage-value'
                              "
                              >{{ opportunity.name }}</strong
                            >
                          }
                        </div>
                      }
                      <!-- Column -->
                    </div>
                    @if (task.oppportunity_info) {
                      <hr
                        class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-0 mb-3"
                      />
                    }
                    @if (task.oppportunity_info) {
                      <div
                        [attr.data-testid]="
                          'completed-task-interested-in-' + task.id
                        "
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-2 block uppercase"
                          [attr.aria-label]="'interested-in-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN'
                              | translate
                          }}
                        </h6>
                        <p-autoComplete
                          [formControlName]="'service_type_ids_' + task.id"
                          field="name_primary_language"
                          [ngClass]="
                            isCompleted(task)
                              ? 'opacity-40 pointer-events-none'
                              : ''
                          "
                          styleClass="w-full"
                          [suggestions]="filtertedServiceType"
                          (completeMethod)="filterServiceType($event)"
                          (onSelect)="
                            UpdateServiceType(false, $event, formGroup, task)
                          "
                          (onUnselect)="
                            UpdateServiceType(true, $event, formGroup, task)
                          "
                          [multiple]="true"
                          [attr.aria-label]="
                            'completed-task-interested-in-autocomplete'
                          "
                          [attr.data-testid]="
                            'completed-task-interested-in-autocomplete'
                          "
                        />
                      </div>
                    }
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="grid align-items-center"
                      [attr.data-testid]="
                        'completed-task-notes-section-' + task.id
                      "
                    >
                      <div
                        class="col-12 md:col-9"
                        [attr.data-testid]="'completed-task-notes-' + task.id"
                      >
                        <h4
                          class="text-sm mb-0 font-bold"
                          [attr.aria-label]="'task-notes-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.TASK-NOTES'
                              | translate
                          }}
                        </h4>
                        <p
                          class="mb-0"
                          [attr.aria-label]="'completed-task-notes-content'"
                        >
                          {{ task.notes }}
                        </p>
                      </div>
                      <!-- Left -->
                      <!-- Right -->
                      <div
                        class="col-12 md:col-3"
                        [attr.data-testid]="
                          'completed-task-assigned-to-' + task.id
                        "
                      >
                        <h6
                          class="font-medium text-700 text-xs mb-0 block uppercase"
                          [attr.aria-label]="'assigned-to-label'"
                        >
                          {{
                            'Shared.TASK-OPPORTUNITY-INFO.ASSIGNED-TO'
                              | translate
                          }}
                        </h6>
                        <staff-selector
                          [formGroup]="formGroup"
                          [controlName]="SelectedAssignedFormControl(task.id)"
                          [ngClass]="
                            isCompleted(task)
                              ? 'opacity-40 pointer-events-none'
                              : ''
                          "
                          [id]="assignedId(task.assigned_to_staff_id)"
                          [styleClass]="'w-full text-sm border-0'"
                          [showClear]="false"
                          [placeHolder]="
                            'common.PLACEHOLDER.SELECT' | translate
                          "
                          (selectedStaff)="getSelectedStaff($event, task)"
                          [attr.aria-label]="
                            'completed-task-assigned-to-selector'
                          "
                          [attr.data-testid]="
                            'completed-task-assigned-to-selector'
                          "
                        />
                      </div>
                      <!-- Right -->
                    </div>
                    <hr
                      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
                    />
                    <div
                      class="cursor-pointer text-sm text-primary flex align-items-center"
                      pStyleClass="@next"
                      enterFromClass="hidden"
                      enterActiveClass="scalein"
                      leaveToClass="hidden"
                      leaveActiveClass="fadeout"
                      [hideOnOutsideClick]="true"
                      [attr.data-testid]="
                        'completed-task-comments-toggle-' + task.id
                      "
                    >
                      <i
                        class="fa fa-comment"
                        [attr.aria-label]="'comments-icon'"
                      ></i>
                      <span class="mx-2" [attr.aria-label]="'comments-count'"
                        >{{ task.comments?.length || 0 }}
                        {{ 'CLIENT_TASK.COMMENTS' | translate }}</span
                      >
                      <i
                        class="fa fa-chevron-down text-xs"
                        [attr.aria-label]="'toggle-comments-icon'"
                      ></i>
                    </div>
                    <div
                      class="hidden"
                      [attr.data-testid]="
                        'completed-task-comments-section-' + task.id
                      "
                    >
                      @if (task.comments && task.comments.length > 0) {
                        <p-table
                          [value]="task.comments"
                          styleClass="shadow-2 p-0 my-3"
                          responsiveLayout="scroll"
                          [attr.data-testid]="
                            'completed-task-comments-table-' + task.id
                          "
                        >
                          <ng-template pTemplate="header">
                            <tr class="text-xs">
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'commenter-header'"
                              ></th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-content-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-date-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT_ON' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-actions-header'"
                              ></th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-comment
                            let-rowIndex="rowIndex"
                          >
                            <tr class="text-sm border-bottom-1 border-300">
                              <td class="py-2 white-space-nowrap relative">
                                <staff-info
                                  [staffId]="comment.comments_updated_by"
                                  [attr.data-testid]="
                                    'commenter-info-' + comment.id
                                  "
                                />
                              </td>
                              <td
                                class="py-2 white-space-nowrap relative"
                                [attr.aria-label]="'comment-content'"
                                [innerHTML]="
                                  sanitizeHtml(comment.comments_content)
                                "
                              ></td>
                              <td
                                class="py-2 white-space-nowrap relative"
                                [attr.aria-label]="'comment-date'"
                              >
                                {{
                                  comment.comments_created_date
                                    | datetimeformat: 'atDate'
                                }}
                              </td>
                              <td class="py-2 white-space-nowrap">
                                <button
                                  pButton
                                  pRipple
                                  type="button"
                                  icon="fa fa-angle-down"
                                  [label]="
                                    'common.BUTTONS.BTN_ACTIONS' | translate
                                  "
                                  iconPos="right"
                                  class="surface-0 p-button-outlined border-400 ml-2 text-600 text-sm"
                                  (click)="commentsAction.toggle($event)"
                                  [attr.aria-label]="'comment-actions-button'"
                                  [attr.data-testid]="
                                    'comment-actions-button-' + comment.id
                                  "
                                ></button>
                                <p-popover
                                  #commentsAction
                                  styleClass="overflow-hidden right-0 text-sm w-6rem"
                                  [attr.aria-label]="'comment-actions-panel'"
                                  [attr.data-testid]="
                                    'comment-actions-panel-' + comment.id
                                  "
                                >
                                  <ul
                                    class="list-none px-0 py-2 text-xs text-600 m-0"
                                  >
                                    <li
                                      class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                                      (click)="DeleteComment(comment)"
                                      [attr.aria-label]="
                                        'delete-comment-button'
                                      "
                                      [attr.data-testid]="
                                        'delete-comment-button-' + comment.id
                                      "
                                    >
                                      <i
                                        class="fa fa-trash-alt text-500 mr-2"
                                      ></i
                                      >Delete
                                    </li>
                                  </ul>
                                </p-popover>
                              </td>
                            </tr>
                            @if (task.comments.length === rowIndex + 1) {
                              <tr
                                class="text-sm border-bottom-1 border-300 vertical-align-top"
                              >
                                <td class="py-2 white-space-nowrap relative">
                                  <staff-info
                                    [staffId]="currentUserDetails.Id"
                                    [attr.data-testid]="'current-user-info'"
                                  />
                                </td>
                                <td
                                  class="py-3 white-space-nowrap relative h-13rem"
                                  colspan="2"
                                >
                                  <p-editor
                                    [formControlName]="
                                      'task_comments_' + task.id
                                    "
                                    styleClass="mb-3"
                                    [style]="{ height: '100px' }"
                                    [attr.aria-label]="'new-comment-editor'"
                                    [attr.data-testid]="
                                      'new-comment-editor-' + task.id
                                    "
                                  />
                                  <p-button
                                    [label]="
                                      'common.BUTTONS.BUTTON-TEXT-SAVE'
                                        | translate
                                    "
                                    [loading]="btnLoading"
                                    (click)="CreateComments(task)"
                                    class="text-sm"
                                    [attr.aria-label]="'save-comment-button'"
                                    [attr.data-testid]="
                                      'save-comment-button-' + task.id
                                    "
                                  />
                                </td>
                              </tr>
                            }
                          </ng-template>
                        </p-table>
                      } @else {
                        <p-table
                          [value]="tableData"
                          styleClass="shadow-2 p-0 my-3"
                          responsiveLayout="scroll"
                          [attr.data-testid]="'empty-comments-table-' + task.id"
                        >
                          <ng-template pTemplate="header">
                            <tr class="text-xs">
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'commenter-header'"
                              ></th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-content-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT' | translate }}
                              </th>
                              <th
                                class="text-xs surface-100 text-600 white-space-nowrap"
                                [attr.aria-label]="'comment-date-header'"
                              >
                                {{ 'CLIENT_TASK.COMMENT_ON' | translate }}
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-data>
                            <tr
                              class="text-sm border-bottom-1 border-300 vertical-align-top"
                            >
                              <td class="py-2 white-space-nowrap relative">
                                <staff-info
                                  [staffId]="currentUserDetails.Id"
                                  [attr.data-testid]="'current-user-info'"
                                />
                              </td>
                              <td
                                class="py-3 white-space-nowrap relative h-13rem"
                                colspan="2"
                              >
                                <p-editor
                                  [formControlName]="'task_comments_' + task.id"
                                  styleClass="mb-3"
                                  [style]="{ height: '100px' }"
                                  [attr.aria-label]="'new-comment-editor'"
                                  [attr.data-testid]="
                                    'new-comment-editor-' + task.id
                                  "
                                />
                                <p-button
                                  [label]="
                                    'common.BUTTONS.BUTTON-TEXT-SAVE'
                                      | translate
                                  "
                                  [loading]="btnLoading"
                                  (click)="CreateComments(task)"
                                  class="text-sm"
                                  [attr.aria-label]="'save-comment-button'"
                                  [attr.data-testid]="
                                    'save-comment-button-' + task.id
                                  "
                                />
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      }
                    </div>
                  </div>
                  <!-- Content -->
                </div>
              }
            }
            <!-- Call Scheduled -->
            <!-- Completed Tasks Pagination -->
            @if (completedTotalItems > completedPageSize) {
              <div
                class="mt-3"
                [attr.data-testid]="'completed-tasks-pagination'"
              >
                <p-paginator
                  [rows]="completedPageSize"
                  [totalRecords]="completedTotalItems"
                  [first]="(completedPage - 1) * completedPageSize"
                  (onPageChange)="onCompletedPageChange($event)"
                  [rowsPerPageOptions]="[10, 25, 50, 100]"
                  [attr.aria-label]="'completed-tasks-paginator'"
                  [attr.data-testid]="'completed-tasks-paginator'"
                />
              </div>
            }
            <!-- Completed Tasks Pagination -->
          </p-tabpanel>
          <!-- End Completed Tasks Tab -->
        </p-tabpanels>
      </p-tabs>
    }

    <!-- Skeleton -->

    <!-- Tasks TabView -->
    <!-- End Tasks TabView -->
  </form>
</div>
<!-- Tabs -->

<p-toast
  position="top-right"
  [breakpoints]="{ '767px': { width: '100%', left: '0' } }"
  [attr.aria-label]="'toast-notifications'"
  [attr.data-testid]="'toast-notifications'"
/>

@if (showCallOutcomePopup) {
  <app-call-outcome
    [visible]="showCallOutcomePopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [data]="outcomeDetail"
    (hideOutCome)="HideOutComePopup($event)"
    (modified)="modified($event)"
    (showClientProfile)="GoToClientDetails($event)"
    [attr.aria-label]="'call-outcome-dialog'"
    [attr.data-testid]="'call-outcome-dialog'"
  />
}

@if (showMeetingOutcomePopup) {
  <app-tour-outcome
    [visible]="showMeetingOutcomePopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [tourOutComeData]="outcomeDetail"
    (hideOutCome)="HideOutComePopup($event)"
    (modified)="modified($event)"
    (showClientProfile)="GoToClientDetails($event)"
    [attr.aria-label]="'tour-outcome-dialog'"
    [attr.data-testid]="'tour-outcome-dialog'"
  />
}

<app-task-create
  [showPopup]="showTaskCreate"
  (onHide)="HideTaskCreate($event)"
  [clientIds]="clientIds"
  (HidePopup)="HideTaskCreate($event)"
  (closeTaskPopup)="closeTaskPopup($event)"
  [attr.aria-label]="'create-task-dialog'"
  [attr.data-testid]="'create-task-dialog'"
/>

<app-task-create
  [showPopup]="showTaskMultiple"
  (onHide)="closeTaskPopup({})"
  [clientIds]="selectedClientIds"
  (HidePopup)="HideTaskCreateMulti($event)"
  [attr.aria-label]="'create-multiple-tasks-dialog'"
  [attr.data-testid]="'create-multiple-tasks-dialog'"
/>
